import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { USER_ROLES } from "@store/constants";
import { StoreSession } from "@store/Services/SessionService";
import { StoreSettingsCollectionModel } from "@store/Services/SettingsService";
import { getRetailModeActive, getRetailModeOn } from "@store/Store/Data/RetailMode/RetailModeSelector";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import getBooleanProperty from "@store/utilities/getBooleanProperty";

export function getStoreSettingsCollection(state: ApplicationState | StoreApplicationState) {
    return state.context.settings.settingsCollection as StoreSettingsCollectionModel;
}

export function getStoreSession(state: ApplicationState | StoreApplicationState) {
    return state.context.session as StoreSession;
}

export function getCurrentLanguage(state: ApplicationState | StoreApplicationState) {
    return state.context.session.language;
}

export function getCurrentCurrency(state: ApplicationState | StoreApplicationState) {
    return state.context.session.currency;
}

export function getWebsiteName(state: ApplicationState | StoreApplicationState) {
    return state.context.website.name;
}

export function getUserProfileId(state: ApplicationState | StoreApplicationState) {
    return state.context.session.userProfileId;
}

export function getUserBillToId(state: ApplicationState | StoreApplicationState) {
    return state.context.session.billToId;
}

export function getUserShipToId(state: ApplicationState | StoreApplicationState) {
    return state.context.session.shipToId;
}

// Settings
export function getBloomreachSettings(state: ApplicationState | StoreApplicationState) {
    return getStoreSettingsCollection(state).bloomreachSettings;
}

export function getWebsiteSettings(state: ApplicationState | StoreApplicationState) {
    return getSettingsCollection(state).websiteSettings;
}

// Policies

export const getPolicyCanSeeNormalPrices = (state: ApplicationState | StoreApplicationState) => {
    const userRoles = state.context.session.userRoles;

    if (!userRoles) {
        return true;
    }

    return userRoles.includes(USER_ROLES.administrator) || !userRoles.includes(USER_ROLES.displayNoPrice);
};

export const getPolicyCanSeeRetailPrices = (state: ApplicationState | StoreApplicationState) => {
    const userRoles = state.context.session.userRoles;

    if (!userRoles) {
        return false;
    }

    return true;
};

export const getPolicyCanSeePrices = (state: ApplicationState | StoreApplicationState) => {
    return getPolicyCanSeeNormalPrices(state) || getRetailModeActive(state);
};

// Pricing Visibility

export const getShowNormalPrice = (state: ApplicationState | StoreApplicationState) => {
    return getPolicyCanSeeNormalPrices(state) && !getRetailModeOn(state);
};

export const getShowRetailPrice = (state: ApplicationState | StoreApplicationState) => {
    return getRetailModeActive(state);
};

export const getShowPrices = (state: ApplicationState | StoreApplicationState) => {
    return getShowNormalPrice(state) || getShowRetailPrice(state);
};

// External Login

export const getIsExternalLogin = (state: ApplicationState | StoreApplicationState) => {
    return getBooleanProperty(getStoreSession(state).properties.externalSignIn);
};

// Default billTo / shipTo

export const getRememberBillToShipTo = (state: StoreApplicationState) => {
    return !!state.store.context.customer.rememberBillToShipTo;
};
